import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { Field, Textarea } from '@hb/coffee';
import { checkCompanyDetails, checkAddressSensitive, validarorTips } from '@/shared/utils/validator';
import { SupplementInfoField } from '@/components/supplement-info-fields/types';
import { emojFilter } from '../../utils';

@Component({ name: 'CompanyAddressDetails' })
export default class CompanyAddressDetails extends Vue implements SupplementInfoField {
  @Prop()
  private value!: string;

  /** 校验器  调用onValidator方法时会优先调用传入的校验器
   * (value, setErrorMsg) => boolean; value为当前输入框输入的值 setErrorMsg是一个设置校验错误信息的函数
  */
  @Prop()
  private validator: ((value: string, setErrorMsg: (msg: string) => void) => boolean) | undefined;

  private companyAddressDetails = '';

  private errorMsg = '';

  private setErrorMsg(msg: string) {
    this.errorMsg = msg;
  }

  public onValidator(): boolean {
    const val = this.companyAddressDetails;
    if (typeof this.validator === 'function') {
      return this.validator(val, this.setErrorMsg.bind(this));
    }

    if (!checkAddressSensitive(val)) {
      this.errorMsg = validarorTips.addressSensitiveTip;
      return false;
    }
    if (!checkCompanyDetails(val)) {
      this.errorMsg = validarorTips.addressLengthTip;
      return false;
    }

    this.errorMsg = '';
    return true;
  }

  private created() {
    if (this.value) {
      this.companyAddressDetails = this.value;
    }
  }

  @Watch('value')
  private onValueChange(val: string) {
    this.companyAddressDetails = val;
  }

  // 清空校验
  private onChangeDetails(val: string) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  private onBlur() {
    this.onValidator();
    this.$emit('blur');
  }

  private render() {
    return (
    <Field
      label="详细地址"
      errorMessage={this.errorMsg}
      >
      <Textarea
        v-model={this.companyAddressDetails}
        placeholder="填写详细地址（不少于5个字）"
        formatter={emojFilter}
        on={{
          'update:modelValue': (val: string) => {
            this.onChangeDetails(val);
          },
        }}
        onBlur={this.onBlur.bind(this)}
      />
    </Field>
    );
  }
}
